var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return !_setup.hide
    ? _c(
        _setup.Button,
        {
          attrs: {
            disabled: _setup.isSaving,
            title: "Save",
            "default-class": _vm.defaultBtnClass,
            "active-class": "btn-warning",
            "active-value": _setup.isModified,
          },
          nativeOn: {
            click: function ($event) {
              return _setup.onClick.apply(null, arguments)
            },
          },
        },
        [
          _vm.buttonText
            ? _c("span", { domProps: { innerHTML: _vm._s(_vm.buttonText) } })
            : _c("span", { staticClass: "bi-save" }),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }